import { fetch } from '../fetchWrapper/fetch';
import { API_URL, Status } from '../constants';

export enum NotificationReadStatus {
  READ = 'READ',
  UNREAD = 'UNREAD',
}

export const updateNotification = async (notificationId: string, status: NotificationReadStatus): Promise<void> => {
  const res = await fetch(`${API_URL}/notifications/${notificationId}`, {
    method: 'PATCH',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({
      status,
    }),
  });

  if (res.status !== Status.NO_CONTENT) {
    throw new Error('Unable to mark notification as read');
  }
};
